import * as React from 'react'
import { PropsWithChildren, useContext, useMemo, useState } from 'react'
import PartialScreenModal from '../components/partial-screen-modal'
import { useModal } from '../utilities/react_hooks'
import { DemocracyEngineDonationForm } from '../components/democracy-engine-donation-form'

type DonationContext = {
  organization: Queries.SanityOrganization
  recipientId: string
  actionId: string
}

export const DemocracyEngineContext = React.createContext<{
  donateTo: (organization: Queries.SanityOrganization, recipientId: string, actionId: string) => void
}>({
  donateTo: () => {}
})

export const DemocracyEngineProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [donationContext, setDonationContext] = useState<DonationContext>()
  const { isOpen, openModal, closeModal } = useModal()

  const donateTo = React.useCallback(
    (organization: Queries.SanityOrganization, recipientId: string, actionId: string) => {
      setDonationContext({ organization, recipientId, actionId })
      openModal()
    },
    []
  )

  const exitModal = React.useCallback(() => {
    closeModal()
    setTimeout(() => {
      setDonationContext(undefined)
    }, 300)
  }, [])

  const value = useMemo(
    () => ({
      donateTo
    }),
    [donateTo]
  )

  return (
    <DemocracyEngineContext.Provider value={value}>
      {children}
      <PartialScreenModal
        open={isOpen}
        onClose={exitModal}
        containerProps={{ sx: { flex: 1, maxHeight: 'calc(100vh - 124px)' } }}
      >
        {donationContext && (
          <DemocracyEngineDonationForm
            organization={donationContext.organization}
            recipientId={donationContext.recipientId}
            actionId={donationContext.actionId}
            onClose={exitModal}
          />
        )}
      </PartialScreenModal>
    </DemocracyEngineContext.Provider>
  )
}

export const democracyEngineState = () => useContext(DemocracyEngineContext)
